import "../../ui/components-lit/GlobalSearch/GlobalSearch";
import { GlobalSearchComponent } from "../../ui/components-lit/GlobalSearch/GlobalSearch";
import { ISearchProvider } from "../../ui/components-lit/GlobalSearch/types";
import { createDefaultProviders } from "./global-search/providers";
import { TGlobalSearchProviderContext } from "./global-search/providers/provider.types";
import { matchesSearchQueryWithIdVariants } from "./global-search/utils/filter";
import { createNavigateModuleAction, createNavigatePanelAction } from "./global-search/utils/navigation-actions";

const GLOBAL_SEARCH_ID = "global-search-root";

/**
 * Maneja la lógica de búsqueda global en la aplicación,
 * proporciona una interfaz para registrar proveedores de búsqueda
 * y realizar búsquedas a través de diferentes módulos como alumnos, escuelas, grupos, etc.
 */
class GlobalSearchService {
    private static _instance: GlobalSearchService;
    private _component: GlobalSearchComponent | null = null;

    private constructor() { }

    static getInstance(): GlobalSearchService {
        if (!GlobalSearchService._instance) {
            GlobalSearchService._instance = new GlobalSearchService();
        }
        return GlobalSearchService._instance;
    }

    init(): void {
        if (document.body) {
            this.mount();
            return;
        }

        document.addEventListener("DOMContentLoaded", () => this.mount(), { once: true });
    }

    refreshProviders(): void {
        if (!this._component) {
            return;
        }

        this._component.providers = this.buildDefaultProviders();
    }

    private mount(): void {
        if (this._component) {
            return;
        }

        const existing = document.getElementById(GLOBAL_SEARCH_ID);
        if (existing && existing instanceof GlobalSearchComponent) {
            this._component = existing as GlobalSearchComponent;
            this.refreshProviders();
            return;
        }

        const element = new GlobalSearchComponent();
        element.id = GLOBAL_SEARCH_ID;
        element.providers = this.buildDefaultProviders();
        document.body.appendChild(element);
        this._component = element;
    }

    private buildDefaultProviders(): ISearchProvider[] {
        const providerContext: TGlobalSearchProviderContext = {
            filter: matchesSearchQueryWithIdVariants,
            navigatePanel: createNavigatePanelAction,
            navigateModule: createNavigateModuleAction,
        };

        return createDefaultProviders(providerContext);
    }
}

export const globalSearchService = GlobalSearchService.getInstance();